import { normalizeVendorListMember } from "./myVendorListsUtils";

/**
 * Maps a sponsor Vendor List API item into the grid / filter view model.
 */
export function mapMyVendorListApiItemToList(item = {}) {
  const rawMembers = item.vendors || item.vendor_metadata || item.members || [];
  const members = Array.isArray(rawMembers)
    ? rawMembers.map(normalizeVendorListMember).filter((m) => m.name || m.providerId)
    : [];

  return {
    id: String(item.id || ""),
    name: item.name || "",
    notes: item.notes || item.description || "",
    isSystemList: Boolean(item.is_system_list ?? item.isSystemList),
    systemKind: item.system_kind ?? item.systemKind ?? null,
    vendorCount: item.vendor_count ?? members.length,
    members,
    /** @deprecated alias — filters accept either `members` or `vendorMetadata` */
    vendorMetadata: members,
    createdAt: item.created_at ?? item.createdAt ?? null,
    createdByName: item.created_by_name ?? item.createdByName ?? null,
    updatedAt: item.updated_at ?? item.updatedAt ?? null,
  };
}

export function mapMyVendorListApiItemsToLists(items = []) {
  return (items || []).map(mapMyVendorListApiItemToList).filter((list) => list.id);
}

/** Maps a create/update API response `{ list }` payload. */
export function mapVendorListMutationResponse(data = {}) {
  return mapMyVendorListApiItemToList(data.list || data);
}
